<template>
  <div class="revenue-flx">
    <div class="revenue-flx-num">
      <div class="item">
        <p class="item-money">
          <span class="label">总金额</span>
          <span class="value orange"
            >￥{{ data.numInfo.totalAmount | formatNumber }}</span
          >
        </p>
        <p class="item-num">
          <span>订单总笔数：</span>
          <span>{{ data.numInfo.orderNum | formatNumber }}</span>
        </p>
      </div>
      <div class="item">
        <p class="item-money">
          <span class="label">退单额</span>
          <span class="value red"
            >￥{{ data.numInfo.returnAmount | formatNumber }}</span
          >
        </p>
        <p class="item-num">
          <span>退订单数：</span>
          <span>{{ data.numInfo.refundNum | formatNumber }}</span>
        </p>
      </div>
    </div>
    <div class="revenue-flx-chart">
      <div class="date-select">
        <Date-picker
          :clearable="false"
          :options="dateOptions"
          :value="dateValue"
          format="yyyy-MM-dd"
          type="daterange"
          placement="bottom"
          placeholder="选择日期"
          style="width: 220px"
          @on-change="handleDate"
        ></Date-picker>
      </div>
      <!-- {{ echartData }} -->
      <Vchart :option="echartData"></Vchart>
    </div>
  </div>
</template>

<script>
import { getWeekDate } from '@utils/utils';
import { DateShortcuts, getBarOptions } from './config';
import Vchart from '@c/Vchart.vue';
export default {
  components: {
    Vchart
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        columns: [],
        rows: []
      })
    }
  },
  data() {
    return {
      dateOptions: {
        shortcuts: [...DateShortcuts]
      },
      dateValue: []
    };
  },
  computed: {
    echartData() {
      const { columns, rows } = this.data.chartData;
      return getBarOptions(columns, rows);
    }
  },
  mounted() {
    const { startDate, endDate } = getWeekDate();
    this.dateValue = [startDate, endDate];
  },
  methods: {
    handleDate(date) {
      this.$eventHub.$emit('onRevenueTime', date);
    }
  }
};
</script>

<style lang="scss" scoped>
.revenue-flx {
  display: flex;
  width: 100%;
  margin-bottom: 30px;
  padding: 30px 20px 0;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #ececee;
  &-num {
    margin-right: 10px;
    .item {
      width: 300px;
      padding: 0 20px;
      margin-bottom: 30px;
      background: #f7f7f9;
      &-money {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 78px;
        border-bottom: 1px solid #eeeeee;
        .label {
          font-size: 14px;
          font-weight: 800;
          color: #444444;
        }
        .value {
          font-size: 24px;
          font-weight: 600;
        }
        .red {
          color: #f56c6c;
        }
        .orange {
          color: #ff8100;
        }
      }
      &-num {
        line-height: 61px;
        height: 61px;
        font-size: 14px;
        color: #444444;
      }
    }
  }
  &-chart {
    position: relative;
    width: calc(100% - 310px);
    height: 310px;
    .date-select {
      display: flex;
      align-items: center;
      position: absolute;
      top: -8px;
      right: 0;
      z-index: 2;
      /deep/.ivu-select-dropdown {
        left: -305px !important;
      }
      /deep/.ivu-tabs-tab {
        padding: 8px 9px;
      }
      /deep/.ivu-tabs-bar {
        border-bottom: 0;
        margin-bottom: 9px;
      }
      /deep/.ivu-tabs-nav .ivu-tabs-tab:hover {
        color: #488ffa !important;
      }
    }
  }
}
</style>
